import { Content } from '../components';
import { DesktopLayout } from '../../components';

const ViewComponent = ({}) => (
  <DesktopLayout>
    <Content />
  </DesktopLayout>
);

ViewComponent.displayName = 'DirectorVerification-Content-view';

export default ViewComponent;
